import {createBrowserHistory} from 'history';
import {sidebar_store} from '@components/Sidebar/Sidebar';

let history = createBrowserHistory();

let unlisten = history.listen((location, actions) => {
    console.log(location, actions)
    sidebar_store.setPathArray();
});

export default history;



// WEBPACK FOOTER //
// ./src/history.js